// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "The ‘Bushfire complex map’  displays the burnt areas captured by NASA satellites. It can highlight one or more active fires including interactive features such as weather forecast, wind direction, rain radar and air quality.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Bushfire hot spots",
  id: "bushfire-hot-spots",
  groupsWithAccess: [],
  linkPrefix: "/interactives",  
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
  "https://www.smh.com.au/interactive/2020/bushfire/data-center/index.html?resizable=true&embed=true&map=firedetection",
    // "https://www.smh.com.au/interactive/2020/bushfire/data-center/stage/index.html?resizable=true&embed=true&map=firedetection",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "BushfireHotSpotsConfigTool" */ "app/components/tools/BushfireHotSpotsConfigTool/BushfireHotSpotsConfigTool"),
    loading: DynamicImportLoader,
    modules: ["BushfireHotSpotsConfigTool"]
  })
};

export default CONFIG;


